import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { injectIntl, intlShape } from 'react-intl';
import { BreadcrumbItem } from './breadcrumb-item';

const Breadcrumb = ({
  currentStep = 1,
  steps = [],
  containerClassName = '',
  onClick = null,
  intl
}) => {
  return (
    <div
      className={classnames('Breadcrumb flex margin-xl-top margin-xl-bottom baseline', containerClassName)}
    >
      {
        steps.map(({ step, text, optonalClassName, disabled, link }, idx) => {
          return (
            <BreadcrumbItem
              key={step}
              step={step}
              link={link}
              text={text}
              disabled={disabled}
              selected={step === currentStep}
              className={optonalClassName}
              arrow={idx < steps.length - 1}
              onClick={onClick}
              intl={intl}
            />
          );
        })
      }
    </div>
  );
};

Breadcrumb.propTypes = {
  currentStep: PropTypes.number,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      step: PropTypes.number,
      text: PropTypes.string,
      optonalClassName: PropTypes.string
    })
  ),
  onClick: PropTypes.func,
  containerClassName: PropTypes.string,
  intl: intlShape
};

export default injectIntl(Breadcrumb);
